import React from "react";
import { MapPin, Phone, Mail, Clock } from "lucide-react";
import { PageHeader, Reveal, SectionHeading } from "@/components/public/ui";
import EnquiryForm from "@/components/public/EnquiryForm";
import { useSite } from "@/context/SiteContext";
import { toMapEmbed } from "@/lib/maps";

export default function LocateUs() {
  const { settings } = useSite();
  const info = [
    { icon: MapPin, label: "Address", value: settings.address },
    { icon: Phone, label: "Phone", value: settings.phone, href: `tel:${(settings.phone || "").replace(/\s+/g, "")}` },
    { icon: Mail, label: "Email", value: settings.email, href: `mailto:${settings.email}` },
    { icon: Clock, label: "Hours", value: "Mon – Sat, 9:30 AM – 6:30 PM" },
  ];
  return (
    <div data-testid="locate-us-page">
      <PageHeader eyebrow="Locate Us" title="Visit or reach our office" subtitle="Get in touch with Aimway Technology Solutions — we're here to help you deploy clean-helmet technology." />
      <section className="container-page py-24">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-2">
          <div>
            <SectionHeading eyebrow="Contact Details" title="Our headquarters" className="mb-8" />
            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
              {info.map((x, i) => (
                <Reveal key={i} delay={i * 0.06}>
                  <div className="rounded-2xl border border-slate-100 bg-white p-6 shadow-card">
                    <div className="mb-3 grid h-11 w-11 place-items-center rounded-xl bg-brand-sky text-brand"><x.icon size={20} /></div>
                    <div className="text-xs uppercase tracking-wide text-muted-foreground">{x.label}</div>
                    {x.href ? <a href={x.href} className="mt-1 block font-600 text-brand-navy hover:text-brand">{x.value}</a> : <div className="mt-1 font-600 text-brand-navy">{x.value}</div>}
                  </div>
                </Reveal>
              ))}
            </div>
            <div className="mt-6 overflow-hidden rounded-2xl border border-slate-100 shadow-card">
              <iframe title="Aimway location" src={toMapEmbed(settings.map_embed, settings.address)} className="h-72 w-full" loading="lazy" referrerPolicy="no-referrer-when-downgrade" data-testid="locate-map" />
            </div>
          </div>
          <div>
            <SectionHeading eyebrow="Quick Enquiry" title="Send us a message" className="mb-8" />
            <EnquiryForm defaultInterest="General Enquiry" />
          </div>
        </div>
      </section>
    </div>
  );
}
